import React, { useContext, useEffect } from 'react';
import { STEPS, OnboardingContext } from '../OnboardingContext';
import Steps from './Steps';
import { BasicInfoForm, CredentialsForm } from './Forms';
import styles from './index.scss';

interface Props {
  basicInfoAltWrapperStyles?: string[];
  accountCreationWrapperStyles?: string[];
  vanillaUrlWrapperStyles?: string[];
  weddingEventDetailsWrapperStyles?: string[];
  setCurrentStep: (step: STEPS) => void;
}

const OnboardingForm: React.FC<Props> = ({
  basicInfoAltWrapperStyles,
  accountCreationWrapperStyles,
  setCurrentStep,
}) => {
  const { step } = useContext(OnboardingContext);
  useEffect(() => setCurrentStep(step), [setCurrentStep, step]);

  return (
    <div className={styles.container}>
      <Steps
        currentStep={step}
        availableSteps={{
          [STEPS.BASIC_INFO]: <BasicInfoForm basicInfoAltWrapperStyles={basicInfoAltWrapperStyles} />,
          [STEPS.ACCOUNT_CREATION]: <CredentialsForm accountCreationWrapperStyles={accountCreationWrapperStyles} />,
        }}
      />
    </div>
  );
};

export default OnboardingForm;
